import { __spread, __decorate, __param, __metadata } from 'tslib';
import { InjectionToken, Injectable, Optional, Inject, Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIKitIconsModule } from '@uikit/components/uk-icons';
import { timer, Subject } from 'rxjs';
import { tap, map } from 'rxjs/operators';

var UK_ALERT_CONFIG = new InjectionToken('UK_ALERT_CONFIG');

var UkAlertService = /** @class */ (function () {
    function UkAlertService(config) {
        this.sameType = false;
        this.alertsInUi = 4;
        this.alerstAtSameType = 2;
        this.alerts = new Array();
        this.alert$ = new Subject();
        if (config) {
            this.sameType = config.sameType;
            this.alertsInUi = config.alertsInUi;
            this.alerstAtSameType = config.alerstAtSameType;
        }
    }
    /**
    * Create an alert
    * @param alert an UKAlert
    * @returns boolean
    */
    UkAlertService.prototype.createAlert = function (alert) {
        var today = Date.now();
        alert.ukGuid = today;
        this.destroySameTypeAlert(alert);
        return true;
    };
    /**
    * Destroy the same type of alert
    * @param alert an UKAlert
    */
    UkAlertService.prototype.destroySameTypeAlert = function (alert) {
        var _this = this;
        var source = timer(alert.ukTimeAlert).pipe(tap(function () { return _this.deleteAlert(alert.ukGuid); })).subscribe();
        var a = 0;
        var isFound = false;
        var len = this.alerts.length;
        var alertToDelete = 0;
        var contAlersSameType = 0;
        while (a < len && !isFound) {
            if (this.alerts[a].ukTypeAlert === alert.ukTypeAlert) {
                if (this.sameType === false) {
                    this.alerts = __spread(this.alerts.splice(a, 1));
                    isFound = true;
                }
                else {
                    if (contAlersSameType < this.alerstAtSameType - 1) {
                        if (contAlersSameType === 0) {
                            alertToDelete = a;
                        }
                        contAlersSameType++;
                    }
                    else {
                        this.alerts.splice(alertToDelete, 1);
                        isFound = true;
                    }
                }
            }
            a++;
        }
        alert.ukSubscription = source;
        this.alerts.push(alert);
        this.alert$.next();
    };
    /**
    * Update an alert
    * @returns Observable<boolean>
    */
    UkAlertService.prototype.updateAlert = function () {
        return this.alert$.pipe(map(function () { return true; }));
    };
    /**
     * Delete an alert
     * @param guid Guid number to delete
     */
    UkAlertService.prototype.deleteAlert = function (guid) {
        var a = 0;
        var isFound = false;
        var len = this.alerts.length;
        while (a < len && !isFound) {
            if (this.alerts[a].ukGuid === guid) {
                this.alerts[a].ukSubscription.unsubscribe();
                this.alerts.splice(a, 1);
                isFound = true;
            }
            a++;
        }
        this.alert$.next();
    };
    UkAlertService = __decorate([
        Injectable(),
        __param(0, Optional()), __param(0, Inject(UK_ALERT_CONFIG)),
        __metadata("design:paramtypes", [Object])
    ], UkAlertService);
    return UkAlertService;
}());

var UkAlertContainerComponent = /** @class */ (function () {
    function UkAlertContainerComponent(UKAlertService, cdr) {
        this.UKAlertService = UKAlertService;
        this.cdr = cdr;
        this.alerts = new Array();
    }
    UkAlertContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.alertSubscription = this.UKAlertService.updateAlert().subscribe(function () {
            _this.alerts = __spread(_this.UKAlertService.alerts);
            _this.cdr.markForCheck();
        });
    };
    UkAlertContainerComponent.prototype.ngOnDestroy = function () {
        this.alertSubscription.unsubscribe();
    };
    UkAlertContainerComponent = __decorate([
        Component({
            selector: "uk-alert-container",
            template: "<ng-container *ngFor=\"let alert of alerts\">\r\n      <uk-alert [alert] = \"alert\"></uk-alert>\r\n</ng-container>",
            changeDetection: ChangeDetectionStrategy.Default
        }),
        __metadata("design:paramtypes", [UkAlertService,
            ChangeDetectorRef])
    ], UkAlertContainerComponent);
    return UkAlertContainerComponent;
}());

var UkAlertComponent = /** @class */ (function () {
    function UkAlertComponent(ukAlertService) {
        this.ukAlertService = ukAlertService;
    }
    Object.defineProperty(UkAlertComponent.prototype, "alert", {
        get: function () {
            return this._alert;
        },
        set: function (value) {
            switch (value.ukTypeAlert) {
                case 1:
                    value.ukClassAlert = 'success';
                    value.ukIconAlert = 'success';
                    break;
                case 2:
                    value.ukClassAlert = 'error';
                    value.ukIconAlert = 'cancel';
                    break;
                case 3:
                    value.ukClassAlert = 'warning';
                    value.ukIconAlert = 'warning';
                    break;
                default:
                    value.ukClassAlert = 'error';
                    value.ukIconAlert = 'cancel';
            }
            this._alert = value;
        },
        enumerable: true,
        configurable: true
    });
    UkAlertComponent.prototype.deleteAlert = function () {
        this.ukAlertService.deleteAlert(this._alert.ukGuid);
    };
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], UkAlertComponent.prototype, "alert", null);
    UkAlertComponent = __decorate([
        Component({
            selector: "uk-alert",
            template: "<div class=\"alert alert-{{alert.ukClassAlert}}\" id=\"alert-{{alert.ukClassAlert}}\">\r\n    <i class=\"icon icon-{{alert.ukClassAlert}}\" [ukIcon]=\"alert.ukIconAlert\"  id=\"icon-{{alert.ukClassAlert}}\"></i>\r\n    <span class=\"child--featured\">{{alert.ukMessageAlert}}</span>\r\n    <i class=\"close-icon\" ukIcon=\"close\" (click)=\"deleteAlert()\" ></i>\r\n</div>"
        }),
        __metadata("design:paramtypes", [UkAlertService])
    ], UkAlertComponent);
    return UkAlertComponent;
}());

var UKAlertModule = /** @class */ (function () {
    function UKAlertModule() {
    }
    UKAlertModule = __decorate([
        NgModule({
            imports: [
                UIKitIconsModule,
                CommonModule
            ],
            declarations: [
                UkAlertComponent,
                UkAlertContainerComponent
            ],
            exports: [
                UkAlertComponent,
                UkAlertContainerComponent
            ],
            providers: [
                UkAlertService
            ]
        })
    ], UKAlertModule);
    return UKAlertModule;
}());

var TypeAlert;
(function (TypeAlert) {
    TypeAlert[TypeAlert["success"] = 1] = "success";
    TypeAlert[TypeAlert["error"] = 2] = "error";
    TypeAlert[TypeAlert["warning"] = 3] = "warning";
})(TypeAlert || (TypeAlert = {}));

export { TypeAlert, UKAlertModule, UK_ALERT_CONFIG, UkAlertService, UkAlertComponent as ɵa, UkAlertContainerComponent as ɵb };
//# sourceMappingURL=uikit-components-uk-alert.js.map
